import Header from "./components/header/header" 
import Sliderm from 'C:\\Users\\KHANAK\\amazon-starterpack\\src\\components\\slider\\slider.jsx'
import Hero from "C:/Users/KHANAK/amazon-starterpack/src/components/hero/hero.jsx" 
import css from 'C:\\Users\\KHANAK\\amazon-starterpack\\src\\App.css'
import Virtual from "C:\\Users\\KHANAK\\amazon-starterpack\\src\\components\\virtual\\virtual.jsx"
import Testimonials from "./components/testimonials/testimonials"
import Products from 'C:\\Users\\KHANAK\\amazon-starterpack\\src\\components\\products\\products.jsx'
function App() {
  return (
    <div className="App">
      <Header/>
      <Hero/>
      <Sliderm/>
      <Virtual/>
      <Products/>
      <Testimonials/>
    </div>
  );
} 

export default App;
